module.exports = __webpack_public_path__ + "img/372.79d7325d.png";